import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import MainTitle from "components/MainTitle";
import { cartwhite, copy, erroricon, whatsapp } from "assets/icons/index";
import Footer from "components/Footer";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Spin, notification } from "antd";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { donationProjectDetailsByIdActions } from "redux/actions/ProjectDetailsByIdActions/donationProjectDetailsByIdActions";
import { useTranslation } from "react-i18next";
import { ADD_TO_CART } from "redux/types";
import SmsDonationPopup from "components/smsDonation/SmsDonationPopup";
import { smsDonationActions } from "redux/actions/SMS Donation/smsDonationActions";
import { userAddCartItemsActions } from "redux/actions/Cart/userAddCartItemsActions";
import { userGetCartItemsActions } from "redux/actions/Cart/userGetCartItemsActions";
import { useFormik } from "formik";
import * as yup from "yup";
import { requestSecureUrlActions } from "redux/actions/RequestSecureUrl/requestSecureUrlActions";

interface amountType {
  amount: string;
}

const InternalSeasonalDetails = () => {
  const [showSmsDonation, setShowSmsDonation] = useState(false);
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const { userId, loginData } = useSelector(
    (state: RootState) => state.loginReducer
  );

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  const { id } = useParams();

  useEffect(() => {
    dispatch(donationProjectDetailsByIdActions(id));
  }, [dispatch, id]);

  const { projectDetailsLoading, projectDetails } = useSelector(
    (state: RootState) => state.donationProjectDetailsByIdReducer
  );

  const onCopy = () => {
    notification.success({
      message: "Copied To Clipboard",
    });
  };

  // console.log(projectDetails);

  ////////////////////////// validating the donation amount
  const formik = useFormik({
    initialValues: {
      amount: "",
    },

    validationSchema: yup.object({
      amount: yup
        .number()
        .typeError(`${t("Amount must be a number")}`)
        .positive(`${t("Amount must be greater than zero")}`)
        .required(`${t("This field is required")}`),
    }),
    onSubmit: async (values: amountType) => {
      dispatch(
        requestSecureUrlActions(
          i18n.language,
          userId ? userId : 0,
          {
            device_info: null,
            projects:
              projectDetails?.donation_type === "Seasonal Projects"
                ? {
                    seasonal_projects: [
                      {
                        id: projectDetails?.id,
                        amount: formik.values.amount,
                      },
                    ],
                  }
                : projectDetails?.donation_type === "Charity Projects"
                ? {
                    internal_projects: [
                      {
                        id: projectDetails?.id,
                        amount: formik.values.amount,
                      },
                    ],
                  }
                : {},
          },
          (urlLink: any) => {
            setTimeout(() => {
              window.open(`${urlLink?.message}`, "_blank");
              // dispatch({ type: "SET_SecureUrlData" });
            }, 1000);
          }
        )
      );
    },
  });

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate ******************************/}
        <QuickDonate />
        {/* quick donate popup  ***********************/}
        {quickDonateStatus && <QuickDonatePopUp />}
        {/* main header section  **********************/}
        <Spin spinning={projectDetailsLoading}>
          <MainTitle
            title={
              i18n.language === "en"
                ? projectDetails?.title_en
                : projectDetails?.title_ar
            }
          />
        </Spin>

        {/* project Details  **************************/}
        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="mainContainer"
        >
          <Spin spinning={projectDetailsLoading}>
            <div className="my-[50px] flex flex-col items-center justify-center lg:flex-row lg:justify-between gap-12">
              {/* img section  */}
              <div className="w-[340px] md:min-w-[50%] h-[244px] rounded-[10px]">
                <Spin spinning={projectDetailsLoading}>
                  {" "}
                  <img
                    className="rounded-[10px] w-full min-h-[244px] max-h-[244px]"
                    src={projectDetails?.image_url}
                    alt=""
                  />
                </Spin>
              </div>

              {/* details section  */}

              <div className="w-full flex flex-col px-[20px] lg:px-0">
                <div
                  className={`font-${
                    i18n.language === "en"
                      ? "Poppins lg:text-left"
                      : "Almarai lg:text-right"
                  } font-[700] text-[22px] lg:text-[32px] text-second_color text-center`}
                >
                  {i18n.language === "en"
                    ? projectDetails?.title_en
                    : projectDetails?.title_ar}
                </div>

                {/* description for moblie only  */}
                <div className="my-[50px] flex flex-col gap-4 lg:hidden">
                  <p
                    className={`${
                      i18n.language === "en"
                        ? "text-second_color text-[24px] lg:text-[30px] font-[600] text-left"
                        : "text-second_color text-[24px] lg:text-[30px] font-[600] text-right"
                    }`}
                  >
                    {t("Project Description:")}
                  </p>
                  <p
                    className={`${
                      i18n.language === "en"
                        ? "font-Poppins lg:text-left"
                        : "font-Almarai lg:text-right"
                    } font-[400] text-[20px] text-[#444444]`}
                    dangerouslySetInnerHTML={{
                      __html: `${
                        i18n.language === "en"
                          ? projectDetails?.description_en
                          : projectDetails?.description_ar
                      }`,
                    }}
                  ></p>{" "}
                </div>

                <div className="flex flex-col items-center md:flex-row gap-4">
                  {/* input fields section */}
                  <div className="w-full flex flex-col gap-4">
                    {/* amount section  */}
                    <div className="my-[16px]">
                      <p
                        className={`font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[600] text-[20px] lg:text-[24px] text-first_color`}
                      >
                        {t("Donation starts from:")} 1
                        {/* <CountUp
                        start={0}
                        end={projectDetails?.amount}
                        duration={6}
                      />{" "} */}
                        {t("AED")}{" "}
                        {/* <span className="font-${i18n.language === "en" ?  "Poppins" : "Almarai"} font-[400] text-[16px] text-second_color">
                      /<CountUp start={0} end={25000} duration={3} /> AED
                    </span> */}
                      </p>
                    </div>

                    {/* first section  */}
                    <div className="w-full">
                      <form
                        onSubmit={formik.handleSubmit}
                        className="w-full flex flex-col gap-2"
                      >
                        <div className="w-full flex items-center gap-2">
                          <input
                            type="number"
                            name="amount"
                            onChange={formik.handleChange}
                            placeholder={`${t("Donation amount")}`}
                            className={`w-full h-[48px] border-[#D3D3D3] border-[1px] rounded-[10px]  placeholder:${
                              i18n.language === "en"
                                ? "font-Poppins pl-[10px]"
                                : "font-Almarai pr-[10px]"
                            } font-[600] placeholder:text-[13px] focus:outline-none pb-[8px]`}
                          />
                          <button
                            type="submit"
                            className={`h-[48px] w-[120px] flex items-center justify-center bg-[#B07F4A] text-[#ffffff] text-[15px] font-${
                              i18n.language === "en" ? "Poppins" : "Almarai"
                            } font-[600] rounded-[15px] hover:bg-[#614629] duration-300`}
                          >
                            {t("Donate")}
                          </button>
                        </div>{" "}
                        {formik.errors.amount && (
                          <p
                            className={`mt-[5px] font-${
                              i18n.language === "en" ? "Poppins" : "Almarai"
                            } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                          >
                            <img
                              className="max-w-[18px]"
                              src={erroricon}
                              alt=""
                            />
                            {formik.errors.amount}
                          </p>
                        )}
                      </form>
                    </div>

                    {/* second section  */}
                    <div className="w-full flex items-center gap-2">
                      {/* sms donation  */}
                      <button
                        onClick={() => {
                          setShowSmsDonation(true);
                          dispatch(
                            smsDonationActions({
                              id: projectDetails?.id,
                              donation_type: projectDetails?.donation_type,
                            })
                          );
                        }}
                        className={`h-[48px] w-full flex items-center justify-center bg-[#E9EBEC] text-[#263A4B] text-[15px] font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[600] rounded-[15px] hover:bg-[#e4cdb4] duration-300`}
                      >
                        {t("SMS Donation")}
                      </button>

                      {/* cart button  */}
                      <button
                        className={`h-[48px] w-[120px] flex items-center justify-center bg-[#B07F4A] text-[#ffffff] text-[15px] font-${
                          i18n.language === "en" ? "Poppins" : "Almarai"
                        } font-[600] rounded-[15px] hover:bg-[#614629] duration-300`}
                        onClick={() => {
                          if (formik.values.amount) {
                            loginData
                              ? dispatch(
                                  userAddCartItemsActions(
                                    i18n.language,
                                    userId,
                                    {
                                      user_id: userId,
                                      device: "web",
                                      project_type:
                                        projectDetails?.donation_type ===
                                        "Charity Projects"
                                          ? "charity_project"
                                          : "seasonal_projects",
                                      id: projectDetails?.id,
                                      duration: 0,
                                      amount: formik.values.amount,
                                    },
                                    () => {
                                      dispatch(
                                        userGetCartItemsActions(
                                          userId,
                                          i18n.language
                                        )
                                      );
                                    }
                                  )
                                )
                              : dispatch(
                                  {
                                    type: ADD_TO_CART,
                                    payload: {
                                      category:
                                        projectDetails?.donation_type ===
                                        "Charity Projects"
                                          ? "internal_projects"
                                          : "seasonal_projects",
                                      project: {
                                        id: projectDetails?.id,
                                        amount: formik.values.amount,
                                        image_url: projectDetails?.image_url,
                                        title_en: projectDetails?.title_en,
                                        title_ar: projectDetails?.title_ar,
                                        duration: 0,
                                        project_type:
                                          projectDetails?.donation_type ===
                                          "Charity Projects"
                                            ? "internal_projects"
                                            : "seasonal_projects",
                                        device: "web",
                                      },
                                    },
                                  },
                                  notification.success({
                                    message: "Added to cart",
                                  })
                                );
                          } else {
                            notification.error({
                              message: `${t("Donation amount is required")}`,
                            });
                          }
                        }}
                      >
                        <img className="min-w-[30px]" src={cartwhite} alt="" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </section>

        {/* project description ***********************/}
        <section
          // data-aos="fade-up"
          // data-aos-duration="900"
          className="mainContainer w-full px-[20px] lg:px-0 hidden lg:block"
        >
          <Spin spinning={projectDetailsLoading}>
            <div className="flex flex-col gap-4">
              <p className="text-second_color text-[24px] lg:text-[30px] font-[600]">
                {t("Project Description:")}
              </p>
              <p
                className={`${
                  i18n.language === "en"
                    ? "font-Poppins lg:text-left"
                    : "font-Almarai lg:text-right"
                } font-[400] text-[20px] text-[#444444] text-center  `}
                dangerouslySetInnerHTML={{
                  __html: `${
                    i18n.language === "en"
                      ? projectDetails?.description_en
                      : projectDetails?.description_ar
                  }`,
                }}
              ></p>{" "}
            </div>
          </Spin>
        </section>

        {/* Our Bank Accounts *************************/}
        <section
          // data-aos="fade-up"
          // data-aos-duration="400"
          className="my-[100px] "
        >
          {/* main title  */}
          <p
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-[32px] text-second_color flex items-center justify-center my-5`}
          >
            {t("Our Bank Accounts")}
          </p>

          {/* bank acconts  */}
          <Spin spinning={projectDetailsLoading}>
            <div className="mainContainer px-[20px] lg:px-0 flex items-center justify-center gap-8 flex-wrap">
              {projectDetails?.banks?.map((bank: any, i: number) => {
                // console.log(bank);
                return (
                  <div
                    key={i}
                    className="w-[300px] shadow-shadow_main p-3 rounded-[10px] flex flex-col gap-4 text-[#263A4B]"
                  >
                    {/* image  */}
                    <div className="w-full">
                      <img
                        className="w-full min-h-[148px] max-h-[148px] rounded-[10px]"
                        src={bank?.logo_url}
                        alt=""
                      />
                    </div>

                    {/* bank name  */}
                    <p
                      className={`${
                        i18n.language === "en" ? "font-Poppins" : "font-Almarai"
                      } text-[16px] font-[600] line-clamp-1 text-ellipsis`}
                    >
                      {/* {i18n.language === "en" ? bank?.name_en : bank?.name_ar} */}
                    </p>

                    {/* Account Name */}
                    <div className="w-full">
                      <p className="text-[12px] text-[#808184]">
                        {t("Account Name")}
                      </p>
                      <CopyToClipboard
                        onCopy={onCopy}
                        text={`${
                          i18n.language === "en" ? bank?.name_en : bank?.name_ar
                        }`}
                      >
                        <p className="flex gap-2 font-[500]">
                          {i18n.language === "en"
                            ? bank?.name_en
                            : bank?.name_ar}{" "}
                          <img className="cursor-pointer" src={copy} alt="" />
                        </p>
                      </CopyToClipboard>
                    </div>

                    {/* Account Number */}
                    <div className="w-full">
                      <p className="text-[12px] text-[#808184]">
                        {t("Account Number")}
                      </p>
                      <CopyToClipboard
                        onCopy={onCopy}
                        text={`${bank?.account_number}`}
                      >
                        <p className="flex gap-2 font-[500]">
                          {bank?.account_number}{" "}
                          <img className="cursor-pointer" src={copy} alt="" />
                        </p>
                      </CopyToClipboard>
                    </div>

                    {/* IBAN */}
                    <div className="w-full">
                      <p className="text-[12px] text-[#808184]">IBAN</p>
                      <CopyToClipboard onCopy={onCopy} text={`${bank?.iban}`}>
                        <p className="flex gap-2 font-[500]">
                          {bank?.iban}{" "}
                          <img className="cursor-pointer" src={copy} alt="" />
                        </p>
                      </CopyToClipboard>
                    </div>
                  </div>
                );
              })}
            </div>
          </Spin>
        </section>

        {/* note section  *****************************/}
        <div className="flex items-center justify-center gap-8 font-[600] text-[12px] lg:text-[22px] text-second_color">
          {t("Note: Please send the receipt upon deposit")}{" "}
          <a
            href="https://wa.me/+97180062"
            target="_blank"
            dir="ltr"
            className="text-second_color text-[12px] lg:text-[22px] hover:text-second_color/85 animate-pulse hover:scale-150 duration-500"
          >
            <img className="w-[30px]" src={whatsapp} alt="" />
          </a>
        </div>
      </main>

      {showSmsDonation && (
        <SmsDonationPopup
          project={projectDetails}
          show={showSmsDonation}
          setShow={setShowSmsDonation}
        />
      )}

      <Footer />
    </>
  );
};

export default InternalSeasonalDetails;
